import { Button } from '@components/Button'
import { HeroTooltip } from '@components/HeroTooltip'
import { XStack } from 'tamagui'

interface IButtonConfig {
  label: string
  onPress: () => void
}

interface ICourseActionButtonsProps {
  buttonConfig: IButtonConfig | undefined
  blockedLabel: string | null
  handleButtonPress: () => void
  progress: number | undefined
  hasExtraContent: boolean
  isLoadingExtraContent: boolean
  handleExtraContentRedirect: () => void
  hasCertification: boolean
  courseCompleted: boolean
  certificateButtonVariant:
    | 'primary'
    | 'success'
    | 'danger'
    | 'secondary'
    | 'disabled'
  handleCertificatePress: () => void
  certificationMinProgress: number
}

export function CourseActionButtons({
  buttonConfig,
  blockedLabel,
  handleButtonPress,
  progress,
  hasExtraContent,
  isLoadingExtraContent,
  handleExtraContentRedirect,
  hasCertification,
  courseCompleted,
  certificateButtonVariant,
  handleCertificatePress,
  certificationMinProgress,
}: ICourseActionButtonsProps) {
  return (
    <XStack
      gap="$spacing-inset-xxs"
      marginTop="$spacing-inset-sm"
      $sm={{
        flexDirection: 'column',
        flexWrap: 'nowrap',
      }}
      $md={{
        flexDirection: 'column',
        flexWrap: 'nowrap',
      }}
    >
      {progress !== 100 &&
        (buttonConfig ? (
          <Button variant="primary" onPress={handleButtonPress}>
            {buttonConfig.label}
          </Button>
        ) : (
          // Nenhum conteúdo liberado: sem isso o botão renderizava sem texto,
          // parecendo quebrado. Mesmo padrão visual do certificado bloqueado.
          // blockedLabel nulo = nada a informar (ex.: acesso expirado), então
          // não renderiza botão nenhum.
          blockedLabel && (
            <Button variant="disabled" outline disabled>
              {blockedLabel}
            </Button>
          )
        ))}

      {hasExtraContent && hasCertification ? (
        <XStack gap="$spacing-inset-xxs">
          <Button
            variant="secondary"
            onPress={handleExtraContentRedirect}
            $xs={{
              paddingHorizontal: '$spacing-inset-quarck',
            }}
            width="100%"
            flex={1}
            disabled={isLoadingExtraContent}
          >
            Material complementar
          </Button>

          <HeroTooltip
            text={`Complete ${certificationMinProgress}% de progresso para receber o certificado`}
            width={158}
            display={!courseCompleted}
          >
            <Button
              variant={certificateButtonVariant}
              outline={!courseCompleted}
              disabled={!courseCompleted}
              onPress={handleCertificatePress}
            >
              Certificado
            </Button>
          </HeroTooltip>
        </XStack>
      ) : hasExtraContent ? (
        <Button
          variant="secondary"
          onPress={handleExtraContentRedirect}
          $xs={{
            paddingHorizontal: '$spacing-inset-quarck',
          }}
          disabled={isLoadingExtraContent}
        >
          Material complementar
        </Button>
      ) : hasCertification ? (
        <HeroTooltip
          text={`Complete ${certificationMinProgress}% de progresso para receber o certificado`}
          width={158}
          display={!courseCompleted}
        >
          <Button
            variant={certificateButtonVariant}
            outline={!courseCompleted}
            disabled={!courseCompleted}
            onPress={handleCertificatePress}
          >
            Certificado
          </Button>
        </HeroTooltip>
      ) : null}
    </XStack>
  )
}
